import JuryProfile from "../../../Components/AdminPanels/JuryProfile";
import ArchitectureJuryProfile from "../../../Components/AdminPanels/ArchitectureJuryProfile";
import MentionContractJuryProfile from "../../../Components/AdminPanels/MentionContractJuryProfile";
import FD100_2025JuryDepartage from "../../Pages/Admin/FD100_2025JuryDepartage";
import Spinner from "../../../Plateforme/Atoms/Spinner";
import FD10025Winners from "./FD10025Winners";
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const OverlayContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
`;

const BlurredContent = styled.div`
    filter: blur(10px);
    pointer-events: none;
    user-select: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

const PopupOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const PopupMessage = styled.div`
    background-color: white;
    padding: 40px 60px;
    border-radius: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    text-align: center;
`;

const MessageText = styled.h2`
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const FDJury = (props) => {
    const { i18n } = useTranslation('common');
    
    if(props.fullUserLoading){
        return <Spinner/>
    }

    if(!props.fullUser){
        return "Veuillez vous connecter.";
    }

    // Check if this is the architecture jury
    const architectureJuryEmails = [
        "houbart@afex.fr",
        "frederic.haboury@culture.gouv.fr",
        "g.lepenhuel@lepenhuel.net",
        "julien.bargeton@citedelarchitecture.fr"
    ];
    const isArchitectureJury = architectureJuryEmails.includes(props.fullUser.user.email);

    // Mention Contract jury emails
    const mentionContractJuryEmails = [
        "julie.millet@ameublement.com",
        "mention@contract.fr",
        "max.flageollet@ameublement.com"
    ];
    const isMentionContractJury = mentionContractJuryEmails.includes(props.fullUser.user.email);

    // Guest jury emails - can view FD100 2025 winners (post-voting view)
    const guestJuryEmails = [
        "vzocchetti@lefigaro.fr",
        "heyalichuree@gmail.com",
        "info@nicolasdenis.com"
    ];
    const isGuestJury = guestJuryEmails.includes(props.fullUser.user.email);

    // Show winners page directly for guest juries
    if (isGuestJury) {
        return <FD10025Winners user={props.fullUser.user} />
    }

    // Show mention contract jury interface
    if (isMentionContractJury) {
        return <MentionContractJuryProfile user={props.fullUser.user} />
    }

    // Show architecture jury interface for architecture jury
    if (isArchitectureJury) {
        return <ArchitectureJuryProfile user={props.fullUser.user} />
    }

    // Enable new jury departage page for FD100 2025
    // To revert to old JuryProfile, comment the next line and uncomment the one after
    // return <FD100_2025JuryDepartage user={props.fullUser.user} />
    // return <JuryProfile user={props.fullUser.user} />
    return <FD10025Winners user={props.fullUser.user} />
    // return (
    //     <OverlayContainer>
    //         <BlurredContent>
    //             <FD10025Winners user={props.fullUser.user} />
    //         </BlurredContent>
    //         <PopupOverlay>
    //             <PopupMessage>
    //                 <MessageText>
    //                     {i18n.language === 'fr' ? 'Sélection bientôt disponible' : 'Selection coming soon'}
    //                 </MessageText>
    //             </PopupMessage>
    //         </PopupOverlay>
    //     </OverlayContainer>
    // );

}

export default FDJury;